module.exports = __webpack_public_path__ + "media/images/cart/cart_btm-32610768dff10760a96037e62337fec4.gif";